import { useLocation } from 'react-router-dom';
import PageSkeleton from './PageSkeleton';
import PartnerDetailSkeleton from './PartnerDetailSkeleton';
import LandingSkeleton from './LandingSkeleton';
import SkeletonDelay from './SkeletonDelay';
import { getSkeletonRoute } from './skeletonRoutes';

export default function RouteSkeleton() {
  const { pathname, key } = useLocation();
  const config = getSkeletonRoute(pathname);
  return <SkeletonDelay key={key}><RouteSkeletonContent config={config} /></SkeletonDelay>;
}

function RouteSkeletonContent({ config }) {
  if (config.variant === 'landing') return <LandingSkeleton />;
  if (config.variant === 'partner-detail') {
    return <PartnerDetailSkeleton className="route-skeleton" />;
  }
  const skeleton = <PageSkeleton variant={config.variant} layout={config.layout} grid={config.grid} count={config.count} fieldColumns={config.fieldColumns} fullPage className={`route-skeleton ${config.width || ''}`} />;
  const content = config.inner ? <div className={config.inner}>{skeleton}</div> : skeleton;
  return config.wrapper ? <div className={config.wrapper}>{content}</div> : content;
}
